<template>
  <el-dialog class="assign-practice-popup" :visible.sync="show" width="600px" center>
    <template #title>设置练习内容</template>

    <template #default>
      <el-form inline>
        <el-form-item label="练习名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>

        <el-form-item label="开始日期">
          <el-date-picker v-model="form.start_datetime"></el-date-picker>
        </el-form-item>

        <el-form-item label="结束日期">
          <el-date-picker v-model="form.end_datetime"></el-date-picker>
        </el-form-item>

        <el-form-item label="选择班级">
          <el-cascader
            v-model="form.class_id_list"
            :options="clazzOptions"
            placeholder="请选择班级"
            :props="{ multiple: true }"
            collapse-tags
            clearable
          ></el-cascader>
        </el-form-item>
      </el-form>

      <div class="footer">
        <el-button @click="back">上一步</el-button>
        <el-button type="primary" @click="assign">确认布置</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { BaseComponent, Component, Emit, Prop, PropSync, Watch } from 'kuaidong-component'
import { Clazz, ICreateExamOrChallengeForm } from 'kuaidong-model'
import { AClazz, AWinter2023 } from 'kuaidong-api'
import { DateUtil, DateWrapper, Debounce } from 'kuaidong-lib'
import { ClassService } from 'kuaidong-service'

@Component({
  components: {},
})
export default class AssignPracticePopup extends BaseComponent {
  @PropSync('visible', { type: Boolean, default: false })
  show!: boolean

  @Prop({ type: String, required: true })
  id!: string

  @Prop({ type: String, required: true })
  name!: string

  get clazzOptions() {
    return ClassService.buildClassOptionsWithNoteName(this.clazzes)
  }

  form: ICreateExamOrChallengeForm = {
    paper_id: this.id,
    paper_type: 'CHALLENGE',
    name: this.name,
    start_datetime: new Date(),
    end_datetime: new Date(),
    question_score: null,
    class_id_list: [],
    grade_ids: [],
  }

  clazzes: Clazz[] = []

  async created() {
    await this.fetchClazzes()
  }

  async fetchClazzes() {
    this.clazzes = await AClazz.allMine()
  }

  validate() {
    if (this.form.name === '') {
      this.$message.error('训练名称不能为空~')
      return false
    }
    if (this.form.class_id_list.length === 0) {
      this.$message.error('请选择布置班级~')
      return false
    }

    const start = new DateWrapper(this.form.start_datetime)

    if (this.form.end_datetime) {
      const end = new DateWrapper(this.form.end_datetime)
      if (end.date < start.date) {
        this.$message.error('结束时间不能小于开始时间~')
        return false
      }
    } else {
      this.$message.error('请选择结束时间~')
    }

    return true
  }

  @Debounce()
  async assign() {
    if (this.validate()) {
      try {
        await AWinter2023.createExamOrChallenge({
          ...this.form,
          end_datetime: DateUtil.endOfDay(this.form.end_datetime as Date),
          class_id_list: this.form.class_id_list.map((option: any) => {
            return option[1]
          }),
        })
        this.$message.success('布置成功~')
        this.show = false
        this.$router.push({
          name: 'pe_knowledge_practice_list',
        })
      } catch (e) {
        this.$message.error('布置失败~')
      }
    }
  }

  @Watch('form.start_datetime')
  updateEndTime() {
    const start = DateUtil.beginningOfDay(new DateWrapper(this.form.start_datetime).date)
    const end = DateUtil.beginningOfDay(new DateWrapper(this.form.end_datetime as Date).date)
    if (start > end) {
      this.form.end_datetime = null
    }
  }

  @Emit('back')
  back() {
    return
  }
}
</script>

<style lang="less">
.assign-practice-popup {
  > .el-dialog {
    padding: 0 100px;
    > .el-dialog__header {
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      color: #0a1629;
    }
    > .el-dialog__body {
      padding: 25px 0;

      > .el-form {
        > .el-form-item {
          > .el-form-item__label {
            width: 68px;
          }
          > .el-form-item__content {
            > .el-input,
            .el-select,
            .el-cascader {
              width: 300px;
            }

            > .total-score {
              color: #cbcbcb;
            }
          }
        }
      }

      > .footer {
        flex: none;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 40px;
        > .el-button {
          width: 135px;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
